import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootState } from 'reducer/store'

const useAuth = (): { isAuthenticated: boolean } => {
  const credentials = useSelector((state: RootState) => state.auth.credentials)
  const { search } = useLocation()

  const params = new URLSearchParams(search)
  const accessToken = params.get('accessToken')

  return { isAuthenticated: !!credentials || !!accessToken }
}

export default useAuth
